/* eslint-disable no-unused-vars */
import { Alert, Box, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import HeaderPageDefault from "pages/admin/components/HeaderPageDefault";
import ItemCardDefault from "pages/admin/components/ItemCardDefault";
import EditModal from "./components/EditModal";
import NewModal from "./components/NewModal";
import SearchAppBar from "components/CODXSearchAppBar/SearchAppBar";
import CustomPaginationActionsTable from "components/CODXTablePagination/TablePaginationActions";
import {
  getAllTrainer,
  newTrainer,
  deleteTrainer,
  patchTrainer,
} from "api/crud/hooks/useProfessores";
import TableTreinadores from "./components/TableTreinadores";
import EmptyCard from "pages/admin/components/EmptyCard";

const PAGE_NAME = "Treinadores";

const Treinadores = () => {
  const [open, setOpen] = React.useState(false);
  const [openText, setOpenText] = React.useState("");
  const [openErr, setOpenErr] = React.useState(false);
  const [openErrText, setOpenErrText] = React.useState("");
  const handleClose = () => setOpen(false);
  const handleCloseErr = () => setOpenErr(false);
  const [busca, setBusca] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    GetItens();
  }, []);

  const GetItens = async () => {
    try {
      const { status, message } = await getAllTrainer();
      if (status === 200) {
        setItems(message);
      } else {
        setItems([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const AddNewItem = async (payload) => {
    try {
      const { status, message } = await newTrainer(payload);
      setRes(status, message);
    } catch (error) {
      console.error(error);
    }
    GetItens();
  };

  const handleDeleteItem = async (id) => {
    try {
      const { status, message } = await deleteTrainer(id);
      setRes(status, message);
    } catch (error) {
      console.error(error);
    }
    GetItens();
  };

  const handlePatchItem = async (id, payload) => {
    try {
      const { status, message } = await patchTrainer(id, payload);
      setRes(status, message);
    } catch (error) {
      console.error(error);
    }
    GetItens();
  };

  const setRes = (status, message) => {
    if (status === 200) {
      setOpenText(message);
      setOpen(true);
    } else {
      setOpenErrText(message);
      setOpenErr(true);
    }
  }

  return (
    <>
      <HeaderPageDefault addFunction={AddNewItem} tittle={PAGE_NAME} NewModal={NewModal} />
      <Box component="main" sx={{ flex: 1, py: 6, px: 4, bgcolor: "#f2f2f2" }}>
        <SearchAppBar
          value={busca}
          onChange={(caracter) => {
            setBusca(caracter);
          }}
        />
        <br />
        {items ? (
          <TableTreinadores
            itens={items}
            busca={busca}
            EditModal={EditModal}
            handleDeleteItem={handleDeleteItem}
            handlePatchItem={handlePatchItem}
          />
        ) : (

          <EmptyCard nome="Treinadores não encontrados" />
        )}
      </Box>
      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          {openText}
        </Alert>
      </Snackbar>
      <Snackbar open={openErr} autoHideDuration={3000} onClose={handleCloseErr}>
        <Alert onClose={handleCloseErr} severity="error" sx={{ width: "100%" }}>
          {openErrText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Treinadores;
